import type { IconCustomType } from "./icon-custom.type";

import AlertSvg from "./svg/alert.svg?react";
import InfoSvg from "./svg/info.svg?react";
import LanguageSvg from "./svg/language.svg?react";
import MobileSvg from "./svg/mobile.svg?react";
import NoTemplateSvg from "./svg/no-template.svg?react";
import SectorSvg from "./svg/sector.svg?react";

export const getIconComponent = (type: IconCustomType) => {
  switch (type) {
    case "availableOnMobile":
      return MobileSvg;
    case "info":
      return InfoSvg;
    case "language":
      return LanguageSvg;
    case "schedulingIssue":
      return AlertSvg;
    case "sector":
      return SectorSvg;
    case "withoutTemplate":
      return NoTemplateSvg;

    default:
      return undefined;
  }
};
